import React from "react";
import Box from "@mui/material/Box";
import TasksKanban from "./TasksKanban";
import InactiveAccountPopup from "../../../../components/CustomPopupBilling/InactiveAccountPopup";
import { useSelector } from "react-redux";

export default function Tasks(props: any) {
  const {
    GetTasksByAssignee,
    GetAllTasksType,
    UpdateTaskStatus,
    GetTasksBoard,
    tasksboard,
    taskStatusUpdateSuccess,
    tasksByAssignee,
    GetLeadListByInstituteAndContact,
    CreateTask,

    GetTasksById,
    taskById,
    taskBoardloading,
    SendRemainders,
    sendRemaindersLoading,
    sendRemaindersSuccess,
  } = props;

  const instituteData = JSON.parse(localStorage.getItem("ACTIVE_INSTITUTE")!);
  const accountStatus = instituteData?.billingStatus;

  const { leadBoard } = useSelector((state: any) => state.nurture);
  const tasksTypes = leadBoard?.taskType;

  return (
    <Box
      sx={{
        overflow: "hidden",
      }}
    >
      <div
        style={{
          minHeight: "calc( 100vh - 65px )",
          maxHeight: "calc( 100vh - 65px )",
          backgroundColor: "#F5F5F5",
          overflow: "hidden",
          position: "relative",
        }}
      >
        <InactiveAccountPopup type={accountStatus} />
        <TasksKanban
          tasks={tasksboard && tasksboard}
          UpdateTaskStatus={UpdateTaskStatus}
          tasksByAssignee={tasksByAssignee}
          GetTasksBoard={GetTasksBoard}
          tasksTypes={tasksTypes}
          taskStatusUpdateSuccess={taskStatusUpdateSuccess}
          GetLeadListByInstituteAndContact={GetLeadListByInstituteAndContact}
          CreateTask={CreateTask}
          taskBoardloading={taskBoardloading}
          SendRemainders={SendRemainders}
          sendRemaindersLoading={sendRemaindersLoading}
          sendRemaindersSuccess={sendRemaindersSuccess}
        />
      </div>
    </Box>
  );
}
